export const design = {
    TREE: 'T',
    COLUMNS: 'C',
    ACTIVATIONS: 'A',
    SUBLEVELS: 'S',
    PACKAGES: 'P'
};

export const report = {
    CONTAINERS: 'O',
    TEMPLATES: 'W',
    SYSTEMFORMATS: 'Y'
};

export const menu = {
    MAINMENU: 'MMP',
    PERSONALMENU: 'PMP'
};

export const splittedScreenSubscreens = [{name: 'FRST'}, {name: 'SCND'}];
